import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppWidget = () => {
  const [showTooltip, setShowTooltip] = useState(true);
  const whatsappNumber = "+34626125436";
  
  const handleClick = () => {
    const message = encodeURIComponent("Hola, me gustaría recibir información sobre la Ley de Segunda Oportunidad");
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  const closeTooltip = (e) => {
    e.stopPropagation();
    setShowTooltip(false);
  };

  return (
    <>
      <div className="whatsapp-widget">
        <button 
          className="whatsapp-button"
          onClick={handleClick}
          aria-label="Contactar por WhatsApp"
        >
          <MessageCircle className="whatsapp-icon" />
          <span className="whatsapp-pulse"></span>
        </button>
        
        {showTooltip && (
          <div className="whatsapp-tooltip">
            <button 
              className="tooltip-close"
              onClick={closeTooltip}
              aria-label="Cerrar mensaje"
            >
              <X size={14} />
            </button>
            <div className="tooltip-content">
              <strong>¿Necesitas ayuda?</strong>
              <p>Escríbenos por WhatsApp</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default WhatsAppWidget;
